import * as React from 'react';
import { SVGProps } from 'react';

export const Tools = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.73788 29.2378C6.21048 29.7652 5.49516 30.0615 4.74929 30.0615C4.00343 30.0615 3.28812 29.7652 2.76071 29.2378C2.23331 28.7104 1.93701 27.995 1.93701 27.2492C1.93701 26.5033 2.23331 25.788 2.76071 25.2607L10.7151 17.3113L14.6922 21.2884L6.73788 29.2378Z"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.9695 7.96216L12.7017 19.2299"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.7484 7.90201C26.3967 8.25356 25.9197 8.45099 25.4225 8.45087C24.9251 8.45075 24.4482 8.2531 24.0967 7.90139C23.7452 7.54966 23.5477 7.07271 23.5479 6.57543C23.548 6.07814 23.7456 5.60127 24.0974 5.24972L27.4121 1.9375L30.0631 4.58729L26.7484 7.90201Z"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.7985 11.1517L10.9363 8.28323C11.2694 7.43492 11.3479 6.50784 11.1621 5.61559C10.9763 4.72334 10.5342 3.90467 9.89011 3.25989C9.13604 2.51116 8.14759 2.04429 7.09034 1.9375C7.53912 2.65471 7.73153 3.50287 7.63617 4.34352C7.54081 5.18418 7.16331 5.96768 6.56528 6.56614C5.96724 7.16461 5.18402 7.54268 4.34343 7.63866C3.50284 7.73463 2.65454 7.54283 1.93701 7.09458C2.01164 7.80868 2.25059 8.49582 2.63516 9.10216C3.01971 9.70848 3.53943 10.2175 4.15359 10.5895C4.76777 10.9614 5.45969 11.186 6.17521 11.2459C6.89071 11.3057 7.61034 11.199 8.27774 10.9343L10.2476 12.9041"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.7856 21.4458L21.0043 23.6632C20.6109 24.6655 20.5746 25.7729 20.9018 26.7988C21.2288 27.8248 21.8991 28.7069 22.8 29.2968C23.701 29.8865 24.7775 30.1482 25.8488 30.0377C26.9199 29.927 27.9203 29.451 28.6818 28.6895C29.4431 27.9282 29.9191 26.9277 30.0298 25.8565C30.1404 24.7854 29.8788 23.7089 29.2889 22.8079C28.699 21.907 27.8169 21.2367 26.791 20.9095C25.765 20.5825 24.6576 20.6188 23.6553 21.012L20.5168 17.8735"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.3641 25.8405C25.1053 25.8405 24.8955 25.6307 24.8955 25.3718C24.8955 25.113 25.1053 24.9031 25.3641 24.9031"
      stroke="#071114"
      strokeWidth="1.5"
    />
    <path
      d="M25.3643 25.8405C25.6231 25.8405 25.833 25.6306 25.833 25.3718C25.833 25.113 25.6231 24.9031 25.3643 24.9031"
      stroke="#071114"
      strokeWidth="1.5"
    />
  </svg>
);
export default Tools;
